import { LS_BLOCKED_USERS } from '@config/localstorage.js'
import { useLocalStorage } from '@vueuse/core'
import { isArray } from '@helpers/utils.js'
import { computed } from 'vue'

const state = useLocalStorage(LS_BLOCKED_USERS, [])

export default function () {
  const blockedUsers = computed(() =>
    isArray(state.value) ? state.value : JSON.parse(state.value)
  )

  function isUserBlocked(nameId) {
    return computed(() => blockedUsers.value.some((u) => u.name_id === nameId))
  }

  function addBlockedUser(user) {
    const newUserArray = [...blockedUsers.value, user]
    setBlockedUsers(newUserArray)
  }

  function removeBlockedUser(user) {
    const newUserArray = blockedUsers.value.filter((u) => u.id !== user.id)
    setBlockedUsers(newUserArray)
  }

  function clearBlockedUsers() {
    setBlockedUsers([])
  }

  function setBlockedUsers(users) {
    state.value = users
  }

  return {
    clearBlockedUsers,
    removeBlockedUser,
    setBlockedUsers,
    addBlockedUser,
    isUserBlocked,
    blockedUsers,
  }
}
